(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hover = matchMedia('(hover: hover)');
  const T = window.theme || { routes: {} };
  const R = T.routes || {};

  const group = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const money = cents => {
    const v = (cents || 0) / 100, fmt = T.moneyFormat || '{{amount}}';
    const map = {
      amount: group(v.toFixed(2).split('.')[0], ',') + '.' + v.toFixed(2).split('.')[1],
      amount_no_decimals: group(Math.round(v).toString(), ','),
      amount_with_comma_separator: group(v.toFixed(2).split('.')[0], '.') + ',' + v.toFixed(2).split('.')[1],
      amount_no_decimals_with_comma_separator: group(Math.round(v).toString(), '.'),
      amount_with_apostrophe_separator: group(v.toFixed(2).split('.')[0], "'") + '.' + v.toFixed(2).split('.')[1],
      amount_with_space_separator: group(v.toFixed(2).split('.')[0], ' ') + ',' + v.toFixed(2).split('.')[1]
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] ?? map.amount);
  };

  /* Header */
  function initHeader(root) {
    const header = $('[data-header]', root);
    if (!header || header.__init) return; header.__init = true;
    const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 40);
    onScroll(); addEventListener('scroll', onScroll, { passive: true });
    const closeAll = () => { $$('.nav-item.is-active', header).forEach(o => o.classList.remove('is-active')); if (!header.classList.contains('menu-open')) header.classList.remove('is-open'); };
    $$('.nav-item', header).forEach(item => {
      const open = () => {
        $$('.nav-item.is-active', header).forEach(o => o !== item && o.classList.remove('is-active'));
        const hasMega = !!$('.mega', item);
        item.classList.toggle('is-active', hasMega);
        header.classList.toggle('is-open', hasMega);
      };
      item.addEventListener('mouseenter', open);
      $('a', item).addEventListener('focus', open);
    });
    header.addEventListener('mouseleave', closeAll);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
    const btn = $('[data-menu-toggle]', header), menu = $('#MobileMenu', header);
    btn && btn.addEventListener('click', () => {
      const open = menu.hidden;
      menu.hidden = !open; btn.setAttribute('aria-expanded', open);
      header.classList.toggle('is-open', open); header.classList.toggle('menu-open', open);
      document.documentElement.classList.toggle('no-scroll', open);
    });
  }

  /* Hero slider */
  function initHero(root) {
    $$('[data-hero]', root).forEach(h => {
      if (h.__init) return; h.__init = true;
      const slides = $$('.hero-slide', h), bars = $$('.hero-bars button', h);
      if (slides.length < 2) return;
      const dur = +h.dataset.interval || 6000; let i = 0, t;
      h.style.setProperty('--hero-dur', dur + 'ms');
      const go = n => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k !== i); });
        bars.forEach((b, k) => {
          b.classList.toggle('is-active', k === i); b.classList.toggle('is-done', k < i); b.setAttribute('aria-current', k === i);
          const f = $('i', b); if (f && k === i) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
        });
        clearTimeout(t); if (!reduce && !window.Shopify?.designMode) t = setTimeout(() => go(i + 1), dur);
      };
      $('[data-hero-prev]', h)?.addEventListener('click', () => go(i - 1));
      $('[data-hero-next]', h)?.addEventListener('click', () => go(i + 1));
      bars.forEach((b, k) => b.addEventListener('click', () => go(k)));
      let x0 = null;
      h.addEventListener('touchstart', e => x0 = e.touches[0].clientX, { passive: true });
      h.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + ((dx < 0) !== (document.dir === 'rtl') ? 1 : -1)); x0 = null; });
      h.addEventListener('shopify:block:select', e => { const k = slides.indexOf(e.target); if (k > -1) { go(k); clearTimeout(t); } });
      go(0);
    });
  }

  /* Generic scroll-snap carousel */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(c => {
      if (c.__init) return; c.__init = true;
      const track = $('[data-track]', c); if (!track) return;
      const items = () => [...track.children];
      const step = () => { const a = items()[0]; if (!a) return track.clientWidth; const gap = parseFloat(getComputedStyle(track).columnGap) || 0; return a.getBoundingClientRect().width + gap; };
      const pages = () => Math.max(1, items().length - Math.round((track.clientWidth + 4) / step()) + 1);
      const idx = () => Math.min(pages() - 1, Math.round(Math.abs(track.scrollLeft) / step()));
      const to = n => { const p = pages(); n = ((n % p) + p) % p; track.scrollTo({ left: (document.dir === 'rtl' ? -1 : 1) * n * step(), behavior: reduce ? 'auto' : 'smooth' }); };
      c.__to = to;
      $$('[data-prev]', c).forEach(b => b.addEventListener('click', () => to(idx() - 1)));
      $$('[data-next]', c).forEach(b => b.addEventListener('click', () => to(idx() + 1)));
      const dots = $('[data-dots]', c);
      const draw = () => {
        const p = pages(), k = idx();
        if (dots) {
          if (dots.children.length !== p) {
            dots.innerHTML = '';
            for (let j = 0; j < p; j++) { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', ((window.bogosT && bogosT.go_to_slide || 'Go to slide')) + ' ' + (j + 1)); b.innerHTML = '<span></span>'; b.addEventListener('click', () => to(j)); dots.append(b); }
          }
          [...dots.children].forEach((b, j) => b.setAttribute('aria-current', j === k));
        }
        $$('[data-goto]', c).forEach(b => b.setAttribute('aria-pressed', +b.dataset.goto === k));
      };
      $$('[data-goto]', c).forEach(b => b.addEventListener('click', () => to(+b.dataset.goto)));
      let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(draw); }, { passive: true });
      addEventListener('resize', draw); draw();
      const ap = +c.dataset.autoplay;
      if (ap && !reduce) {
        let t; const start = () => { clearInterval(t); t = setInterval(() => to(idx() + 1), ap); };
        c.addEventListener('mouseenter', () => clearInterval(t)); c.addEventListener('mouseleave', start);
        c.addEventListener('touchstart', () => clearInterval(t), { passive: true });
        start();
      }
    });
  }

  function initTabs(root) {
    $$('[data-tabs]', root).forEach(w => {
      const tabs = $$('[role=tab]', w), panels = $$('[role=tabpanel]', w);
      tabs.forEach((t, k) => t.addEventListener('click', () => {
        tabs.forEach((x, j) => x.setAttribute('aria-selected', j === k));
        panels.forEach((p, j) => p.hidden = j !== k);
      }));
    });
  }

  function initCountdown(root) {
    $$('[data-countdown]', root).forEach(el => {
      let end = Date.parse((el.dataset.countdown || '').trim().replace(' ', 'T'));
      if (isNaN(end)) { const d = new Date(); d.setHours(23, 59, 59, 0); end = d.getTime(); }
      const cells = $$('[data-unit]', el);
      const tick = () => {
        const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        cells.forEach(c => c.textContent = String(v[c.dataset.unit]).padStart(2, '0'));
      };
      tick(); clearInterval(el.__t); el.__t = setInterval(tick, 1000);
    });
  }

  function initBest(root) {
    $$('[data-best]', root).forEach(w => {
      const links = $$('[data-best-link]', w), imgs = $$('[data-best-img]', w), cap = $('[data-best-caption]', w);
      const set = k => {
        links.forEach((l, j) => l.classList.toggle('is-active', j === k));
        imgs.forEach((m, j) => m.classList.toggle('is-active', j === k));
        if (cap) cap.textContent = links[k]?.dataset.caption || '';
      };
      links.forEach((l, k) => { l.addEventListener('mouseenter', () => set(k)); l.addEventListener('focus', () => set(k)); });
      set(0);
    });
  }

  function initHotspots(root) {
    $$('[data-hotspot]', root).forEach(h => {
      const b = $('button', h);
      b.addEventListener('click', e => {
        e.stopPropagation();
        const open = !h.classList.contains('is-open');
        $$('[data-hotspot].is-open').forEach(x => { x.classList.remove('is-open'); $('button', x).setAttribute('aria-expanded', false); });
        h.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      });
      h.addEventListener('mouseenter', () => { if (hover.matches) h.classList.add('is-open'); });
      h.addEventListener('mouseleave', () => { if (hover.matches) h.classList.remove('is-open'); });
    });
  }
  document.addEventListener('click', e => { if (!e.target.closest('[data-hotspot]')) $$('[data-hotspot].is-open').forEach(x => x.classList.remove('is-open')); });

  function initWords(root) {
    $$('[data-words]', root).forEach(p => {
      if (p.__init) return; p.__init = true;
      const words = p.textContent.trim().split(/\s+/); p.textContent = '';
      const spans = words.map(w => { const s = document.createElement('span'); s.textContent = w + ' '; p.append(s); return s; });
      if (reduce) return;
      const upd = () => {
        const r = p.getBoundingClientRect();
        const prog = Math.min(1, Math.max(0, (innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35)));
        const n = prog * spans.length;
        spans.forEach((s, k) => s.style.opacity = k < n ? 1 : .22);
      };
      upd(); addEventListener('scroll', upd, { passive: true });
    });
  }

  function initReveal(root) {
    if (reduce || document.body.classList.contains('no-anim') || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
    document.documentElement.classList.add('js-reveal');
    const io = initReveal.io || (initReveal.io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return; e.target.classList.add('is-in'); io.unobserve(e.target);
    }), { threshold: .12, rootMargin: '0px 0px -40px 0px' }));
    $$('[data-reveal]', root).forEach(el => io.observe(el));
    $$('[data-reveal-stagger]', root).forEach(g => [...g.children].forEach((c, i) => { c.setAttribute('data-reveal', ''); c.style.setProperty('--d', (i % 4) * 90 + 'ms'); io.observe(c); }));
  }

  /* Product forms */
  function initProducts(root) {
    $$('[data-product]', root).forEach(p => {
      if (p.__init) return; p.__init = true;
      const json = $('[data-product-json]', p); if (!json) return;
      const data = JSON.parse(json.textContent);
      const form = $('form[action*="/cart/add"]', p), id = form && $('[name=id]', form), btn = $('[data-add]', p);
      const sets = $$('[data-option]', p);
      const update = () => {
        const opts = sets.map(fs => $('input:checked', fs)?.value);
        sets.forEach((fs, k) => { const l = $('[data-option-value]', fs); if (l) l.textContent = opts[k] || ''; });
        const v = data.variants.find(v => v.options.every((o, k) => o === opts[k]));
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = (window.bogosT && bogosT.unavailable || 'Unavailable'); } return; }
        id.value = v.id;
        $$('[data-price]', p).forEach(el => el.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : ''));
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : (window.bogosT && bogosT.sold_out || 'Sold out'); }
        if (v.featured_media) {
          const gal = document.querySelector('[data-gallery]'), m = gal && gal.querySelector('[data-media-id="' + v.featured_media.id + '"]');
          if (m) { if (gal.scrollWidth > gal.clientWidth) gal.scrollTo({ left: m.offsetLeft - gal.offsetLeft, behavior: 'smooth' }); else if (m !== gal.firstElementChild) gal.prepend(m); }
        }
        if (p.hasAttribute('data-update-url')) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
      };
      p.addEventListener('change', e => { if (e.target.closest('[data-option]')) update(); });
    });
  }
  document.addEventListener('click', e => {
    const s = e.target.closest('[data-qty-step]'); if (!s) return;
    const i = s.parentElement.querySelector('input'); if (!i) return;
    i.value = Math.max(+i.min || 0, (+i.value || 0) + +s.dataset.qtyStep); i.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Recommendations */
  function initRecs(root) {
    $$('[data-recommendations]', root).forEach(async el => {
      if (el.__init) return; el.__init = true;
      try {
        const r = await fetch(el.dataset.url); const html = await r.text();
        const d = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
        if (d && d.innerHTML.trim()) { el.innerHTML = d.innerHTML; init(el); } else el.closest('.shopify-section')?.setAttribute('hidden', '');
      } catch (_) {}
    });
  }

  /* Cart */
  const Cart = {
    el: () => $('#CartDrawer'),
    open() {
      const d = this.el(); if (!d) { location.href = R.cart; return; }
      document.documentElement.classList.add('drawer-open', 'no-scroll'); d.setAttribute('aria-hidden', 'false');
      setTimeout(() => $('[data-cart-close]', d)?.focus(), 50);
    },
    close() { const d = this.el(); document.documentElement.classList.remove('drawer-open', 'no-scroll'); d?.setAttribute('aria-hidden', 'true'); },
    render(html) {
      if (!html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawerInner');
      const cur = $('#CartDrawerInner');
      if (fresh && cur) { cur.replaceWith(fresh); init(fresh); }
      const n = fresh?.dataset.count;
      if (n != null) $$('[data-cart-count]').forEach(e => { e.textContent = n; e.hidden = n === '0'; });
    },
    async post(url, body) {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json(); if (j.status && j.status >= 400 || j.status === 'bad_request') throw new Error(j.description || j.message || (window.bogosT && bogosT.something_went_wrong || 'Something went wrong'));
      return j;
    },
    async add(form) {
      const fd = new FormData(form); const body = { items: [{ id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) }], sections: ['cart-drawer'], sections_url: location.pathname };
      const j = await this.post(R.cartAdd + '.js', body); this.render(j.sections?.['cart-drawer']); this.open();
    },
    async change(line, quantity) {
      const d = this.el(); d?.classList.add('is-loading');
      try { const j = await this.post(R.cartChange + '.js', { line, quantity, sections: ['cart-drawer'], sections_url: location.pathname }); this.render(j.sections?.['cart-drawer']); }
      finally { d?.classList.remove('is-loading'); }
    }
  };
  window.BogosCart = Cart;
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-open]') && Cart.el()) { e.preventDefault(); Cart.open(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); Cart.close(); }
    const rm = e.target.closest('[data-line-remove]'); if (rm && Cart.el()?.contains(rm)) { e.preventDefault(); Cart.change(+rm.dataset.line, 0); }
    const tg = e.target.closest('[data-toggle-panel]');
    if (tg) { const p = document.getElementById(tg.dataset.togglePanel); if (p) { p.hidden = !p.hidden; tg.setAttribute('aria-expanded', !p.hidden); } }
  });
  document.addEventListener('change', e => {
    const q = e.target.closest('[data-line-qty]'); if (q && Cart.el()?.contains(q)) Cart.change(+q.dataset.line, Math.max(0, +q.value));
    const note = e.target.closest('[data-cart-note]'); if (note) Cart.post(R.cartUpdate + '.js', { note: note.value }).catch(() => {});
    if (e.target.closest('.js-localization select')) e.target.form.submit();
    const ff = e.target.closest('[data-filter-form]') || (e.target.form && e.target.form.matches('[data-filter-form]') && e.target.form);
    if (ff && e.target.type !== 'number') ff.requestSubmit ? ff.requestSubmit() : ff.submit();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { Cart.close(); closePopup(); } });
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[action*="/cart/add"]'); if (!f || !Cart.el() || T.cartType !== 'drawer') return;
    e.preventDefault();
    const btn = f.querySelector('[type=submit]'), err = f.querySelector('[data-form-error]');
    btn?.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
    Cart.add(f).catch(x => { if (err) { err.textContent = x.message; err.hidden = false; } else alert(x.message); }).finally(() => btn?.removeAttribute('aria-busy'));
  });

  /* Copy link */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-copy-link]'); if (!b) return;
    navigator.clipboard?.writeText(b.dataset.copyLink || location.href);
    b.classList.add('is-copied'); b.setAttribute('aria-label', (window.bogosT && bogosT.link_copied || 'Link copied')); setTimeout(() => { b.classList.remove('is-copied'); b.setAttribute('aria-label', (window.bogosT && bogosT.copy_link || 'Copy link')); }, 2000);
  });

  /* Popup */
  const KEY = 'bogos_popup_seen';
  function closePopup() { const p = $('[data-popup]'); if (!p || p.hidden) return; p.classList.remove('is-open'); try { localStorage.setItem(KEY, Date.now()); } catch (_) {} setTimeout(() => p.hidden = true, 350); }
  function initPopup(root) {
    const p = $('[data-popup]', root); if (!p) return;
    const show = () => { p.hidden = false; requestAnimationFrame(() => p.classList.add('is-open')); };
    p.addEventListener('click', e => { if (e.target === p || e.target.closest('[data-popup-close]')) closePopup(); });
    if ($('.form-success', p) && /customer_posted=true/.test(location.search)) return show();
    if (window.Shopify?.designMode) return;
    let seen = null; try { seen = localStorage.getItem(KEY); } catch (_) {}
    const days = +p.dataset.days || 7;
    if (seen && Date.now() - +seen < days * 864e5) return;
    setTimeout(show, (+p.dataset.delay || 4) * 1000);
  }

  function initFilters(root) {
    $$('[data-filters-details]', root).forEach(d => { if (matchMedia('(max-width: 989px)').matches) d.open = false; });
  }

  function init(root = document) {
    initHeader(root); initHero(root); initCarousels(root); initTabs(root); initCountdown(root); initBest(root);
    initHotspots(root); initWords(root); initProducts(root); initRecs(root); initFilters(root); initReveal(root);
    if (root === document) initPopup(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => { init(e.target); if (e.target.querySelector('[data-popup]')) { const p = e.target.querySelector('[data-popup]'); p.hidden = false; p.classList.add('is-open'); p.addEventListener('click', ev => { if (ev.target === p || ev.target.closest('[data-popup-close]')) { p.classList.remove('is-open'); p.hidden = true; } }); } });
  document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('#CartDrawer')) Cart.open(); });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('#CartDrawer')) Cart.close(); });
})();
